import http from '@/utils/http'
import { setCookie, getCookie, removeCookie, setLocalStorage } from '@/utils/auth'
import router from '@/router'

const user = {
  state: {
    session: getCookie('iot-session'),
    account: getCookie('iot-account'),
    nickname: getCookie('iot-nickname'), // 昵称默认为账号
    roleClass: '',
    accountImg: (() => {
      return getCookie('iot-img') ? getCookie('iot-img') : '//xiot-app.oss-cn-hangzhou.aliyuncs.com/iot_home/images/common/img_user.png'
    })(),
    hasSignIn: (() => {
      if (getCookie('iot-session')) {
        return true
      } else {
        return false
      }
    })(),
    lang: window.localStorage.hasOwnProperty('iot-lang') ? window.localStorage.getItem('iot-lang') : 'zh',
    // lang: getCookie('iot-lang') ? getCookie('iot-lang') : 'zh',
    comActive: '', // 社区点击活跃时间
    allreadStatus: true
  },
  mutations: {
    SET_ACCOUNT: (state, account) => {
      state.account = account
      setCookie('iot-account', account)
    },
    SET_NICKNAME: (state, nickname) => {
      state.nickname = nickname
      setCookie('iot-nickname', nickname)
    },
    SET_ROLECLASS: (state, roleClass) => {
      state.roleClass = roleClass
    },
    SET_IMG: (state, img) => {
      state.accountImg = img
      setCookie('iot-img', img)
    },
    SET_HASSIGNIN: (state, bol) => {
      state.hasSignIn = bol
    },
    SET_LANG: (state, lang) => {
      state.lang = lang
    },
    SET_COM_ACTIVE: (state) => {
      let active = Date.now()
      state.comActive = active
    },
    SET_ALL_NOTICE_READED: (state, status) => {
      state.allreadStatus = status
    },
    CLEAN_COOKIE: (state) => {
      removeCookie('iot-session')
      removeCookie('iot-account')
      removeCookie('iot-nickname')
      removeCookie('iot-img')
    }
  },
  actions: {
    login ({commit}, data) {
      return new Promise((resolve, reject) => {
        http.iot_post('/v5/users/login', data.data, data.encryptKeys).then(res => {
          setCookie('iot-session', res.data.session)
          commit('SET_HASSIGNIN', true)
          commit('SET_ACCOUNT', res.data.account)
          let img = getCookie('iot-img') ? getCookie('iot-img') : '//xiot-app.oss-cn-hangzhou.aliyuncs.com/iot_home/images/common/img_user.png'
          commit('SET_IMG', img)
          resolve(res)
        }).catch(err => {
          console.log('登录失败', err)
          reject(err)
        })
      })
    },
    telLogin ({commit}, data) {
      return new Promise((resolve, reject) => {
        http.iot_post('/v4/users/telephone/login', data).then(res => {
          setCookie('iot-session', res.data.session)
          commit('SET_HASSIGNIN', true)
          commit('SET_ACCOUNT', res.data.account)
          commit('SET_IMG', '//xiot-app.oss-cn-hangzhou.aliyuncs.com/iot_home/images/common/img_user.png')
          resolve(res)
        }).catch(err => {
          console.log('登录失败', err)
          reject(err)
        })
      })
    },
    logOut ({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('SET_HASSIGNIN', false)
        commit('SET_IMG', '')
        commit('SET_ACCOUNT', '')
        commit('SET_NICKNAME', '')
        commit('CLEAN_COOKIE')
        router.replace({ path: '/' })
        resolve(true)
      })
    },
    cleanCookie ({commit}) {
      commit('CLEAN_COOKIE')
      commit('SET_HASSIGNIN', false)
    },
    getUserInfo ({commit}) {
      return new Promise((resolve, reject) => {
        http.iot_get('/v4/users/account').then(res => {
          commit('SET_HASSIGNIN', true)
          commit('SET_ACCOUNT', res.data.account)
          commit('SET_NICKNAME', res.data.nickname)
          commit('SET_ROLECLASS', res.data.class)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    setAllNoticeReaded ({commit}, status) {
      commit('SET_ALL_NOTICE_READED', status)
    },
    // 获取通知数据
    checkNoticeStatus ({commit}) {
      http.iot_get('/v4/notice/list/user', {
        offset: 0,
        num: 15
      }).then(res => {
        if (res.data.item) {
          if (!res.data.item[0].readFlag) {
            commit('SET_ALL_NOTICE_READED', false)
          } else {
            commit('SET_ALL_NOTICE_READED', true)
          }
        } else {
          commit('SET_ALL_NOTICE_READED', true)
        }
      })
    },
    // 获取权限资源
    getResourceRights () {
      // 获取资源权限
      http.iot_get('/v4/resources/system/rights').then(res => {
        console.log('获取权限资源', res)
        if (res.data) {
          setLocalStorage('rights', JSON.stringify(res.data))
        }
      })
    },
    // 获取模块数据配置
    getModuleConfig () {
      http.iot_get('/control/v2/sensor_infos').then(res => {
        console.log('获取拓展模块配置信息', res)
        if (res.data) { // 存储模块配置信息，必须以字符串形式存储
          setLocalStorage('types', JSON.stringify(res.data.types ? res.data.types : {}))
          setLocalStorage('r_type', JSON.stringify(res.data.r_type ? res.data.r_type : []))
          setLocalStorage('format', JSON.stringify(res.data.format ? res.data.format : []))
          setLocalStorage('formula', JSON.stringify(res.data.formula ? res.data.formula : []))
          setLocalStorage('units', JSON.stringify(res.data.units ? res.data.units : []))
          setLocalStorage('baud_rate', JSON.stringify(res.data.baud_rate ? res.data.baud_rate : []))
          setLocalStorage('parity', JSON.stringify(res.data.parity ? res.data.parity : []))
        }
      })
    },
    // 设置语言
    setIotLang ({commit}, lang) {
      console.log('设置iot-lang', lang)
      commit('SET_LANG', lang)
      window.localStorage.setItem('iot-lang', lang)
      // setCookie('iot-lang', lang)
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/stores/modules/user.js